import { cn } from "@/packages/utils/cn";

const TONES = {
  ok: "bg-signal-ok-soft text-signal-ok border-signal-ok/30",
  warn: "bg-signal-warn-soft text-signal-warn border-signal-warn/30",
  red: "bg-signal-red-soft text-signal-red border-signal-red/30",
  lavender: "bg-signal-lavender-soft text-signal-lavender border-signal-lavender/30",
  ink: "bg-panel text-foreground border-rule",
} as const;

export type Tone = keyof typeof TONES;

interface Props {
  tone?: Tone;
  children: React.ReactNode;
  className?: string;
}

export function StatusBadge({ tone = "ink", children, className }: Props) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full font-mono text-[10px] font-bold tracking-[0.06em] uppercase border",
        TONES[tone],
        className,
      )}
    >
      <span className="size-1.5 rounded-full bg-current" aria-hidden="true" />
      {children}
    </span>
  );
}

export function statusToTone(status?: string): Tone {
  switch (status) {
    case "published":
    case "live":
    case "active":
      return "ok";
    case "draft":
    case "processing":
      return "warn";
    case "failed":
    case "error":
      return "red";
    default:
      return "ink";
  }
}
